'use strict';
import currentLayout from './detect-layout';

let RESPONSIVE_IMAGE_TAG = 'picture';

/*
* @Object
* @description a delayedimageload object for showing the images based on the data- attribute value
*/
var delayedimageload = {
	/**
	* @function
	* @description init function initialises the triggers and assigns the onload, ready elements.
	*/
	init: function () {
		this.$eldesktoponly = $('img[data-image-load-on=desktop]');
		$(window).on('resize orientationchange', function () {
			delayedimageload.showDesktopImages();
		});
	},
	/**
	* @function
	* @description A function to display all the images on document ready specifically
	*/
	showDesktopImages: function () {
		if (this.$eldesktoponly && currentLayout.init() === 'desktop') {
			var $desktopImageIndex = 0;
			var $desktopImagesLength = this.$eldesktoponly.length;
			for ($desktopImageIndex; $desktopImageIndex < $desktopImagesLength; $desktopImageIndex++) {
				var $desktopImage = this.$eldesktoponly[$desktopImageIndex];
				var $currentElement = $($desktopImage);
				if (!$currentElement.hasClass('js-loaded')) {
					showResponsiveImages($currentElement);
					$currentElement.attr('src', $currentElement.attr('data-image'));
					$currentElement.addClass('js-loaded');
				}
			}
		}
	}
};

function showDelayedImages() {
	delayedimageload.init();
	delayedimageload.showDesktopImages();
}

/**
* @function
* @description A function to determine and lazy-load responsive images
*/
function showResponsiveImages(image) {
	var $parentNode = image.parent();
	if ($parentNode.prop('tagName').toLowerCase() === RESPONSIVE_IMAGE_TAG) {
		var $imageSources = $parentNode.children();
		for (var i = 0; i < $imageSources.length; i++) {
			var $element = $imageSources.eq(i);
			$element.attr('srcset', $element.data('srcset'));
		}
	}
}

export default {
	delayedimageload : delayedimageload,
	showDelayedImages : showDelayedImages
};
